<template>
  <div id="demo">
    <van-loading
      v-if="loading"
      size="24px"
      class="loading"
      vertical>
      加载中...
    </van-loading>
    <template  v-else-if="url">
      <div class="pdf">
        <pdf class="pdf-canvas" :src="url" :page="currentPage" @num-pages="pageCount=$event" 
      @page-loaded="currentPage=$event" 
      @loaded="loadPdfHandler"/>
      </div>
      <div class="page-change">
        <van-button size="small" type="primary"  @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</van-button>
        {{currentPage}} / {{pageCount}}
        <van-button size="small" type="primary"  @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</van-button>
      </div>
    </template>
  </div>

</template>
<script>
import vuePdf from 'vue-pdf';
import api from '@/api';

const pdf = {...vuePdf,destroyed:undefined};

export default {
  components: {
    pdf
  },
  data() {
    return {
      loading: true,
      url: '',
      currentPage: 1,
      pageCount: 0,
    }
  },
  mounted() {
    this.initPdf();
    this.handleBack();
	},
  methods: {
    handleBack() {
      const _this = this
      let options = {
        disabled: true,
        callback: function() {
          if (window.history.length > 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.replace({ name: 'articleList' })
          }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    renderedHandler() {
            console.log("渲染完成")
        },
        errorHandler() {
            console.log("渲染失败")
        },
    async initPdf() {
      const { data, code } = await api.getEBookList();
      if (code === 200) {
        let pdfInfo = data?.find((item) => +item.id === +this.$route.params.id);
        if (!pdfInfo?.downUrl) {
          this.$toast({
            type: 'fail',
            message: '电子书不存在',
          })
          return;
        }
        this.url = pdfInfo?.downUrl?.replace(
          'http://s3-internal.cn-north-1.jdcloud-oss.com',
          '/shendengFile',
        )
        this.loading = false;
      } else {
        this.$toast({
          type: 'fail',
          message: '加载失败',
        })
      }
      // 
      
    },
    changePdfPage (val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    loadPdfHandler () {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
  }

}
</script>
<style lang="less" scoped>
.pdf {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-canvas {
  width: 100%;
}
.page-change {
  position: fixed;
  bottom: 12px;
  text-align: center;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turn {
  margin: 0 16px;
}
</style>